<template>
  <aha-modal
    :title="title_PresentationIsPrivate"
    @hide="$emit('hideModal')"
  >
    <div>
      {{ $i18nPresenter.t("Your audience won't be able to see your slides or interact from their devices. Would you like to proceed?") }}
    </div>
    <template #action>
      <aha-button
        @click="switchToPublicMode()"
        has-margin-right
        :submitting="isSwitchingPrivateMode"
      >
        {{ $i18nPresenter.t('Switch to public') }}
      </aha-button>
      <aha-button variant="base" @click="hideModalAndMaybePresent()">
        {{ $i18nPresenter.t('Present anyway') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'
import PresentationApi from '@/api/presentation'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    isShowCorrectAnswerReminder: {
      type: Function,
      default: () => {},
    },
    isAudiencePacing: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    isSwitchingPrivateMode: false,
  }),
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    title_PresentationIsPrivate() {
      return this.$i18nPresenter.t('Presentation is private')
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSlideActiveAction', 'setSyncLoadingAction']),
    switchToPublicMode() {
      EventBus.$emit('setLoadingPrivateMode', {
        isSwitchingPrivateMode: true,
      })
      this.isSwitchingPrivateMode = true
      this._updatePresentation()
    },

    async _updatePresentation() {
      try {
        this.setSyncLoadingAction(1)
        if (this.$store.state.presentIsBeginning) {
          const firstSlide = this.presentation.slides[0]

          if (firstSlide.id) {
            this.updateSlideActiveAction({
              id: null,
            })
            this.setSlideActiveAction(firstSlide)
            EventBus.$emit('eventHandleSetValueTransition')
          }
        }

        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, {
          privateMode: !this.presentation.privateMode,
        })
        this.setSyncLoadingAction(2)
        this._handleAfterUpdate()
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
      }
    },

    _handleAfterUpdate() {
      EventBus.$emit('setLoadingPrivateMode', {
        isSwitchingPrivateMode: false,
      })
      this.isSwitchingPrivateMode = false
      this.$emit('hideModal')
      if (this.isShowCorrectAnswerReminder()) return
      // this.$emit('setScreenMode')
      // this.$emit('changeRouterIfPresenting')
      this.$emit('startPresenting')
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Editor header > Present Button > Modal private mode reminder pops up > Presenter switch to public mode on presenting prompt',
        `Presentation id: ${this.presentation.id}`,
      )
    },

    hideModalAndMaybePresent() {
      this.$emit('hideModal')
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Editor Header > Present Button > Modal private mode reminder pops up > Presenter clicks on Present anyway', `Presentation id: ${this.$store.state.presentation.id}`)
      if (this.isShowCorrectAnswerReminder()) return
      if (this.isAudiencePacing()) return
      this.$emit('startPresenting')
    },
  },
}
</script>
